/**
 * Shared toast callback utilities for favourite and archive actions
 */

/**
 * Create a favourite success callback
 * @param setMessage - Function to set the toast message
 * @param setOpen - Function to open the toast
 * @returns Callback function for favourite success
 */
export const createFavouriteSuccessCallback = (
  setMessage: (message: string) => void,
  setOpen: (open: boolean) => void
) => {
  return (isFavourited: boolean, type: 'video' | 'image') => {
    const action = isFavourited ? 'added to' : 'removed from';
    const itemType = type === 'video' ? 'Video' : 'Image';
    setMessage(`${itemType} ${action} favorites`);
    setOpen(true);
  };
};

/**
 * Create an archive success callback
 * @param setMessage - Function to set the toast message
 * @param setOpen - Function to open the toast
 * @returns Callback function for archive success
 */
export const createArchiveSuccessCallback = (
  setMessage: (message: string) => void,
  setOpen: (open: boolean) => void
) => {
  return (isArchived: boolean, type: 'video' | 'image') => {
    const action = isArchived ? 'added to' : 'removed from';
    const itemType = type === 'video' ? 'Video' : 'Image';
    setMessage(`${itemType} ${action} archives`);
    setOpen(true);
  };
};
